import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sceneConstructorBgColorMenu" }
const _hoisted_2 = { class: "sceneConstructorBgColorMenu__body" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_4 = { class: "sceneConstructorBgColorMenu__picker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_SceneConstructorMenu = _resolveComponent("SceneConstructorMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SceneConstructorMenu, {
      showBackButton: true,
      onGoBack: _cache[1] || (_cache[1] = () => _ctx.store.goTo('bgMenu'))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('scene_constructor.select_color')), 1),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ColorPicker, {
              modelValue: _ctx.backgroundColor,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.backgroundColor) = $event)),
              inline: true
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}